
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[tickerSymbol]/valuation",
      function () {
        return require("private-next-pages/[country]/[tickerSymbol]/valuation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[country]/[tickerSymbol]/valuation"])
      });
    }
  